module.exports = __webpack_public_path__ + "img/thrivent.fc4b673b.jpeg";